import { useEffect, useState } from "react";
import { api, apiConfigured, type PlatformStatus } from "../lib/api";

export type ApiState<T> =
  | { kind: "loading" }
  | { kind: "not-configured" }
  | { kind: "ready"; data: T }
  | { kind: "unavailable"; detail?: string };

export function usePlatformStatus(): ApiState<PlatformStatus> {
  const [state, setState] = useState<ApiState<PlatformStatus>>(
    apiConfigured ? { kind: "loading" } : { kind: "not-configured" },
  );

  useEffect(() => {
    if (!apiConfigured) return;
    let active = true;
    api
      .status()
      .then((data) => active && setState({ kind: "ready", data }))
      .catch((error: unknown) =>
        active
          ? setState({ kind: "unavailable", detail: error instanceof Error ? error.message : undefined })
          : undefined,
      );
    return () => {
      active = false;
    };
  }, []);

  return state;
}
